import 'jquery';

export default () => {

    $(document).on('click', '#personal-tabs a', function(e) {
        e.preventDefault();
        $(this).tab('show');
    });
    $('#personal-tabs li:first-child a').addClass('active');
    $('.js-personal-tab .tab-pane:first-child').addClass('active');

};


// WEBPACK FOOTER //
// ./scripts/modules/tabs.js